/* eslint-disable */
import React, { CSSProperties, FunctionComponent, ReactNode, useCallback, useRef, useState } from 'react'
import DateRangePicker from '../DatePicker'
import { IDateRangePickerWidgetProps } from '../DatePicker/DateRangePickerWidget'
import ConnectedDateRangeInput, { RangeType } from './index'

const DateRangeInputContainer = ({
                                   dateFrom,
                                   dateTo,
                                   changeDateFrom,
                                   changeDateTo,
                                   disabledDays,
                                   children,
                                   containerStyles,
                                   allowEndOnDisabledDay = true,
                                   allowSingleDay = false,
                                   minDate,
                                   maxDate,
                                   withYearPicker = false,
                                   ...rest
                                 }: IDateRangeInputContainerProps) => {
  const [open, setOpen] = useState(false)
  const [focus, setFocus] = useState(RangeType.Start)
  const dateFromRef = useRef(null as HTMLDivElement)
  const dateToRef = useRef(null as HTMLDivElement)
  const toggleOpen = (toggle: boolean) => () => setOpen(toggle)
  const onDateFromClick = () => {
    toggleOpen(true)()
    setFocus(RangeType.Start)
  }
  const onDateToClick = () => {
    if (!dateFrom) {
      onDateFromClick()
    } else {
      toggleOpen(true)()
      setFocus(RangeType.End)
    }
  }
  const onFocusChange = (focus: RangeType) => {
    setFocus(focus)
  }
  const DateFromInput = useCallback(
    props => (
      <ConnectedDateRangeInput
        {...props}
        dateRangeRef={dateFromRef}
        onClick={onDateFromClick}
      />
    ),
    [dateFrom, dateTo],
  )

  const DateToInput = useCallback(
    props => (
      <ConnectedDateRangeInput
        {...props}
        dateRangeRef={dateToRef}
        onClick={onDateToClick}
      />
    ),
    [dateFrom, dateTo],
  )

  return (
    <>
      {children({ DateFromInput, DateToInput })}
      <DateRangePicker
        open={open}
        anchorEl={dateFromRef.current}
        arrowRef={
          focus === RangeType.Start ? dateFromRef.current : dateToRef.current
        }
        onClose={toggleOpen(false)}
        initialEndDate={dateTo}
        initialStartDate={dateFrom}
        initialFocus={focus}
        onFocusChange={onFocusChange}
        onEndDateChange={changeDateTo}
        onStartDateChange={changeDateFrom}
        disabledDays={disabledDays}
        styles={containerStyles}
        allowEndOnDisabledDay={allowEndOnDisabledDay}
        allowSingleDay={allowSingleDay}
        minDate={minDate}
        maxDate={maxDate}
        withYearPicker={withYearPicker}
        {...rest}
      />
    </>
  )
}
export default DateRangeInputContainer

export interface IDateRangeInputContainerProps extends IDateRangePickerWidgetProps {
  dateFrom?: Date
  dateTo?: Date
  changeDateFrom?: (date: Date) => void
  changeDateTo?: (date: Date) => void
  disabledDays?: Date[]
  children: (props: IChildrenFunction) => ReactNode
  containerStyles?: CSSProperties
  allowEndOnDisabledDay?: boolean
  allowSingleDay?: boolean
  minDate?: Date,
  maxDate?: Date
  withYearPicker?: boolean
}

interface IChildrenFunction {
  DateFromInput: FunctionComponent
  DateToInput: FunctionComponent
}
